export default "__VITE_ASSET__BnOc$OB5__"